// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, createOrUpdate, get, listByPrivateCloud } from "./operations.js";
export {
  IscsiPathsDeleteOptionalParams,
  IscsiPathsCreateOrUpdateOptionalParams,
  IscsiPathsGetOptionalParams,
  IscsiPathsListByPrivateCloudOptionalParams,
} from "./options.js";
